export default __webpack_public_path__ + "static/media/bnb.4356c7e1.png";